import React, { useEffect, useState } from 'react'
import { List, Typography, Tag, Tooltip } from 'antd';
import moment from 'moment';
import { CloseCircleOutlined, CheckCircleOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import Avatar from '../avatar/avatar';

const {Text} = Typography

export default function Timeline({
    changes
}) {

    const [dataSource, setDataSource] = useState([])
    // eslint-disable-next-line
    const [sortByOldest, setSortByOldest] = useState(true) 

    useEffect(() => {
        let newDataSource = changes ?? []

        if(sortByOldest === true) {
            newDataSource.sort(function(a,b){
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(b.changedAt) - new Date(a.changedAt);
              });
        }
        else {
            newDataSource.sort(function(a,b){
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(a.changedAt) - new Date(b.changedAt);
              });
        }

        setDataSource(newDataSource)

    }, [changes, sortByOldest])

    function getDescription(column, oldValue, newValue) {

        switch(column) {
            case "Background":
                return (
                    <>
                        <Text>the background </Text>
                    </>
                )
            case "Personal possesions":
                return (
                    <>
                        <Text>Personal possesions </Text>
                    </>
                )
            case "Add skill":
                return (
                    <>
                        <Text>Added skill </Text>
                        <Tag color="green">{newValue}</Tag>
                    </>
                )
            case "Remove skill":
                return (
                    <>
                        <Text >Removed skill </Text>
                        <Tag color="red">{oldValue}</Tag>
                    </>
                )
            case "Status":
                return (
                    <>
                    <Text strong>{column}</Text>
                    <Text> from </Text>
                    {getStatus(oldValue)}
                    <Text>to </Text>
                    {getStatus(newValue)}
                </>
                )
            default:
                break;
        }

        function getStatus(name) {
            switch(name) {
                case "Rejected":
                  return (
                    <Tag icon={<CloseCircleOutlined />} color="error">
                        {name}
                    </Tag>
                  )
                case "Accepted by SL":
                  return (
                    <Tag icon={<CheckCircleOutlined />} color="success">
                        {name}
                    </Tag>
                  )
                case "Review for SL":
                  return (
                    <Tag icon={<ExclamationCircleOutlined />} color="warning">
                        {name}
                    </Tag>
                  )
                case "Changed after Accepted":
                    return (
                        <Tag icon={<InfoCircleOutlined />} color="default">
                            {name}
                        </Tag>
                    )
                default:
                    return (<Tag>
                        {name}
                    </Tag>)
            }
        }
        return (
            <>
                <Text strong>{column}</Text>
                <Text> from </Text>
                <Tag>{oldValue}</Tag>
                <Text>to </Text>
                <Tag>{newValue}</Tag>
            </>
        )
    }

    function calculateDifferentTime(item) {
        // const newTime = moment(item.changedAt)
        const duration = moment(item.changedAt).fromNow()

        if (duration.includes('months') || duration.includes('month') || duration.includes('year') || duration.includes('years')) {
            return moment(item.changedAt).format("YYYY-MM-DD HH:mm:ss");;
        }

        return duration;
    }

    function getAvatar(larper) {
     
        return (
            <Tooltip title={larper.name}>
                <Avatar name={larper.name} />
            </Tooltip>
        )
    }

    // const menu = (
    //     <Menu>
    //       <Menu.Item key="1">
    //         <Button type="text" onClick={() => setSortByOldest(true)}>
    //             Sort by newest first
    //         </Button>
    //       </Menu.Item>
    //       <Menu.Item key="2">
    //         <Button type="text" onClick={() => setSortByOldest(false)}>
    //             Sort by oldest first
    //         </Button>
    //       </Menu.Item>
    //     </Menu>
    //   );

    return (
        <>
            {/* <Dropdown overlay={menu} placement="bottomLeft" trigger={['click']}>
                <Button icon={<MoreOutlined />} />
            </Dropdown> */}
            <List
                itemLayout="horizontal"
                dataSource={dataSource}
                size="small"
                pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50', '100']}}
                renderItem={item => (
                    <List.Item>
                        <List.Item.Meta
                        avatar={getAvatar(item.larper)}
                        description={`changed ${calculateDifferentTime(item)}`}
                        //description={`From "${item.oldValue}" to "${item.newValue}"`}
                        title={getDescription(item.column, item.oldValue, item.newValue)}
                        />
                    </List.Item>
                )}
            />
        </>
    )

}